import * as t from 'io-ts';

import {RCreateContactFormState} from '../../createContactForm/createContactFormState';
import {
  ContactsManagerSidePanelTypesEnum,
  RContactsManagerSidePanelStateBase,
} from './contactsManagerSidePanelStateBase';

/*
 * Runtime types.
 */

export const RContactsManagerCreateContactFormState = t.intersection([
  RContactsManagerSidePanelStateBase,
  RCreateContactFormState,
  t.type({
    type: t.literal(ContactsManagerSidePanelTypesEnum.CREATE_CONTACT),
  }),
]);

/*
 * Types.
 */

export interface ContactsManagerCreateContactFormState
  extends Readonly<t.TypeOf<typeof RContactsManagerCreateContactFormState>> {
  avatarFile: File | undefined;
}
